<template>
  <div>
    <div
      v-if="!isFormVisible && !bitacoraItems.length"
      class="bg-secondary-13 rounded my-3 "
    >
      <div class="col-12 py-4 text-center">
        <button
          class="btn bg-light-white w-50"
          @click="isFormVisible = !isFormVisible"
        >
          <em class="fas fa-file-plus pr-4 text-green" />
          <span class="text-button-add-document">
            Presione aquí para añadir bitácora
          </span>
        </button>
      </div>
    </div>
    <BitacoraForm
      v-if="isFormVisible"
      @cancel="isFormVisible = !isFormVisible"
      @submit="handleSubmit"
    />
    <BitacoraResultRow
      v-for="item in bitacoraItems"
      :key="item.id"
      :comment="item.comment"
      :date="item.date"
      :file-alias="item.fileAlias"
      :file-id="item.fileId"
      :filename="item.filename"
      :user="item.user"
      @download="handleDownloadFile"
    />
    <div
      v-if="!isFormVisible && bitacoraItems.length"
      class="d-flex justify-content-end"
    >
      <action-button
        i="fas fa-file-plus"
        text="Añadir"
        variant="success"
        @click="isFormVisible = !isFormVisible"
      />
    </div>
  </div>
</template>

<script>
import BitacoraForm from './BitacoraForm.vue';
import BitacoraResultRow from './BitacoraResultRow.vue';

import alertMixin from '@/mixins/alert.mixin.js';

import _generalApi from '@/modules/app/api.js';
import {
  addBitacoraItem,
  getBitacoraItems,
} from '@/modules/proposalProcess/api.js';

export default {
  name: 'BitacoraManager',
  components: {
    BitacoraForm,
    BitacoraResultRow,
  },
  mixins: [alertMixin],
  data: () => ({
    isFormVisible: false,
    bitacoraItems: [],
  }),
  computed: {
    proposalRequestId() {
      return this.$route.params.id ?? this.$route.params.proposalRequestId;
    },
  },
  async mounted() {
    await this.fetchBitacoraItems(this.proposalRequestId);
  },
  methods: {
    buildFormData(data) {
      const formData = new FormData();
      formData.append('comment', data.comment);
      formData.append('fileAlias', data.fileAlias);
      formData.append('file', data.file);

      return formData;
    },
    async fetchBitacoraItems() {
      const { data } = await getBitacoraItems(this.proposalRequestId);
      this.bitacoraItems = data;
    },
    async handleSubmit(payload) {
      try {
        await addBitacoraItem(
          this.proposalRequestId,
          this.buildFormData(payload)
        );

        this.isFormVisible = !this.isFormVisible;
        await this.fetchBitacoraItems(this.proposalRequestId);

        this.ShowToast(
          '',
          'La información ha sido añadida exitosamente.',
          'success'
        );
      } catch (err) {
        this.ShowToast(
          '',
          'Error al agregar nueva información a la bitacora.',
          'error'
        );
      }
    },
    async handleDownloadFile(fileId) {
      try {
        if (!fileId) return;
        await _generalApi.downloadDocument(fileId);
      } catch (err) {
        this.ShowToast('', 'Error al descargar el documento.', 'error');
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
